export default __webpack_public_path__ + "static/media/soudeur_small.0d23370b.png";